{
    "Hello, ": "¡Hola, ",
    "E-Mail Address": "Correo electrónico",
    "Password": "Contraseña",
    "Remember Me": "Recuérdame",
    "Login": "Acceder",
    "Forgot Your Password?": "¿Olvidaste tu contraseña?",
    "Register": "Registro",
    "Confirm": "Confirmar",
    "Name": "Nombre",
    "Personal data": "Datos personales",
    "Account data": "Datos de cuenta",
    "Academic data": "Datos académicos",
    "Miscellaneous data": "Datos misceláneos",
    "Medical data": "Datos médicos",
    "Confirm Password": "Confirmar contraseña",
    "Reset Password": "Restablecer contraseña",
    "Identity/Passport card": "DNI/Pasaporte",
    "Confirm Identity/Passport card": "Confirmar DNI/Pasaporte",
    "Reset Password Notification": "Aviso para restablecer contraseña",
    "Only numbers": "Solo números",
    "Full name": "Nombre completo",
    "First name": "Nombres",
    "Last name": "Apellidos",
    "Gender": "Género",
    "Male": "Masculino",
    "Female": "Femenino",
    "Birthdate": "Fecha de nacimiento",
    "Phone number": "Número de teléfono",
    "Major": "Carrera",
    "Other major": "Otra carrera",
    "College": "Universidad",
    "Other college": "Otra universidad",
    "Credits": "Materias aprobadas",
    "Credits required": "Materias totales",
    "Work experience": "Experiencia laboral",
    "NGO experience": "Experiencia en ONG",
    "Yes": "Sí",
    "No": "No",
    "Where?": "¿Dónde?",
    "Allergies and relevant medical information": "Alergias e información médica relevante",
    "Healthcare provider": "Obra social o compañía de seguro médico prepaga",
    "Shoe size": "Talle de zapatillas",
    "Shirt size": "Talle de remeras",
    "Diet & health conditions": "Dietas y condiciones de salud",
    "Celiac disease": "Enfermedad celíaca",
    "Lactose intolerant": "Intolerante a la lactosa",
    "Vegetarian": "Vegetariano",
    "Vegan": "Vegano",
    "Ketogenic diet": "Dieta cetogénica",
    "Other...": "Otra...",
    "Country": "País",
    "State/Province": "Provincia/Estado",
    "City": "Ciudad",
    "Address": "Domicilio",
    "Do not include food allergies. Please, specify those in the Diet & health conditions section.": "No incluyas alergias alimenticias. Por favor, indicalas en la sección de dietas y condiciones de salud.",
    "Should your dietetic needs not be listed, please write to us at": "Si tus necesidades dietéticas no están listadas, por favor escribinos a",
    "If possible, use the following nomenclature:": "Dentro de lo posible, usá la siguiente convención:",
    "+{1-digit country code} {3-digit area code} {3-digit office code}-{4-digit line number}": "+{cód. país} {cód. área sin 0} {nro. teléfono sin 15}",
    "E.g., +1 650 513-0514": "Por ejemplo: +54 343 4975100 - Argentina (54), Paraná (343)",
    "You are receiving this email because we received a password reset request for your account.": "Estás recibiendo este email porque se ha solicitado un cambio de contraseña para tu cuenta.",
    "This password reset link will expire in :count minutes.": "Este enlace para restablecer la contraseña caduca en :count minutos.",
    "If you did not request a password reset, no further action is required.": "Si no has solicitado un cambio de contraseña, puedes ignorar o eliminar este e-mail.",
    "Please confirm your password before continuing.": "Por favor confirme su contraseña antes de continuar.",
    "Regards": "Saludos",
    "Whoops!": "¡Ups!",
    "Hello!": "¡Hola!",
    "If you’re having trouble clicking the \":actionText\" button, copy and paste the URL below\ninto your web browser: [:actionURL](:actionURL)": "Si tienes problemas haciendo click en el botón \":actionText\", copia y pega el siguiente\nenlace en tu navegador: [:actionURL](:actionURL)",
    "If you’re having trouble clicking the \":actionText\" button, copy and paste the URL below\ninto your web browser: [:displayableActionUrl](:actionURL)": "Si tienes problemas haciendo click en el botón \":actionText\", copia y pega el siguiente\nenlace en tu navegador: [:displayableActionUrl](:actionURL)",
    "If you’re having trouble clicking the \":actionText\" button, copy and paste the URL below\ninto your web browser:": "Si tienes problemas haciendo click en el botón \":actionText\", copia y pega el siguiente\nenlace en tu navegador:",
    "Send Password Reset Link": "Enviar enlace para restablecer contraseña",
    "Logout": "Cerrar sesión",
    "Verify Email Address": "Confirmar correo electrónico",
    "Please click the button below to verify your email address.": "Por favor pulsa el siguiente botón para confirmar tu correo electrónico.",
    "If you did not create an account, no further action is required.": "Si no has creado ninguna cuenta, puedes ignorar o eliminar este e-mail.",
    "Verify Your Email Address": "Confirma tu correo electrónico",
    "A fresh verification link has been sent to your email address.": "Se ha enviado un nuevo enlace de verificación a tu correo electrónico.",
    "Before proceeding, please check your email for a verification link.": "Antes de poder continuar, por favor, confirma tu correo electrónico con el enlace que te hemos enviado.",
    "If you did not receive the email": "Si no has recibido el email",
    "click here to request another": "pulsa aquí para que te enviemos otro",
    "All rights reserved.":  "Todos los derechos reservados."
}
